module.exports = __webpack_public_path__ + "static/img/nonLoginTxt.5904776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/nonLoginTxt.png
// module id = Xk1L
// module chunks = 2